import React, {Component, Fragment} from 'react';
import {Route, Routes} from 'react-router-dom'
import {withTranslation} from 'react-i18next';
import {
  withStyleguide,
  FormController,
  withAuthentication,
  withRouter,
  Loading,
  FormUtility,
  GelContentContainer,
  NotFound,
  PageTracking
} from "cw-styleguide-react";
import {route} from "./routes";
import LandingController from "./controllers/LandingController";
import StepController from "./controllers/StepController";
import ResultController from "./controllers/ResultController";
import {BreadcrumbsItem} from 'react-breadcrumbs-dynamic';
import {Helmet} from "react-helmet";
import axios from "axios";
import config from "./config";
import i18n from "./i18n";

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      questions: null,
      answers: {
        step1Question1: '',
        step1Question2: '',
        step1Question3: '',
        step1Letter: '',
        step2Question1: '',
        step2Question2: '',
        step2Question3: '',
        step2Letter: '',
        step3Question1: '',
        step3Question2: '',
        step3Question3: '',
        step3Letter: '',
        step4Question1: '',
        step4Question2: '',
        step4Question3: '',
        step4Letter: '',
      }
    }

    this.retrieveQuestion = this.retrieveQuestion.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.checkAllAnswersHaveBeenSelected = this.checkAllAnswersHaveBeenSelected.bind(this);
  }

  componentDidMount() {
    if (this.props.authentication.hasHandledRedirectPromise && this.props.location.pathname !== route('whoAmI')) {
      this.props.navigate(route('whoAmI'));
    }

    const toggledLangcode = this.props.i18n.language === 'en' ? 'cy' : 'en';
    this.props.styleguide.setLanguageUrl(route('whoAmI', null, toggledLangcode).substr(1));
    this.props.styleguide.setStaticBreadcrumbs([{to: route('myFuture'), text: this.props.t('misc.myFuture')}]);

    // Load the questions from the API.
    this.loadQuestions();
  }

  componentDidUpdate(prevProps) {
    if (this.props.authentication.hasHandledRedirectPromise && this.props.location.pathname !== route('whoAmI') && (this.props.authentication.hasHandledRedirectPromise !== prevProps.authentication.hasHandledRedirectPromise)) {
      this.props.navigate(route('whoAmI'));
    }
  }


  /**
   * Load questions.
   */
  loadQuestions() {
    axios.get(config.endpoints.questions, {
      headers: {
        'Accept-Language': i18n.language
      }
    })
      .then(response => {

        this.setState({questions: response.data});
      })
      .catch(error => {
        this.props.setError(error);
      });
  }

  /**
   * Retrieve a specific question.
   * @param id
   * @returns {{result2Subtitle: (string|*), question3Answer2: *, question2Answer1: *, question3Answer1: *, result2List, question3VideoThumbnail: *, question1VideoAlt: *, question1Answer1: *, question1Answer2: *, result1Subtitle: (string|*), title, body, step1Title, question2Answer2: *, step4Title, result1List, result2Image1: *, question3VideoLocation, result2Image2, step3Title, question2VideoLocation, result2: string, question1VideoLocation, result1: string, result1Title, question2VideoThumbnail: *, step2Title, question3VideoDuration, question1VideoDuration, image1: *, result2Title, image2: *, question2VideoDuration, question3VideoAlt: *, subtitle: (string|*), question1VideoThumbnail: *, question2VideoAlt: *, result1Image1: *, result1Image2}}
   */
  retrieveQuestion(id) {
    const result1 = Object.keys(this.state.questions.questions[id].results)[0].toString();
    const result2 = Object.keys(this.state.questions.questions[id].results)[1].toString();

    return {
      id: id,
      title: this.state.questions.questions[id].title,
      subtitle: this.state.questions.questions[id].subtitle,
      body: this.state.questions.questions[id].body,
      step1Title: this.state.questions.questions[0].title,
      step2Title: this.state.questions.questions[1].title,
      step3Title: this.state.questions.questions[2].title,
      step4Title: this.state.questions.questions[3].title,
      question1Answer1: this.state.questions.questions[id].questions.q1[0],
      question1Answer2: this.state.questions.questions[id].questions.q1[1],
      question2Answer1: this.state.questions.questions[id].questions.q2[0],
      question2Answer2: this.state.questions.questions[id].questions.q2[1],
      question3Answer1: this.state.questions.questions[id].questions.q3[0],
      question3Answer2: this.state.questions.questions[id].questions.q3[1],
      image1: this.state.questions.questions[id].media.images.column1,
      image2: this.state.questions.questions[id].media.images.column2,
      question1VideoLocation: this.state.questions.questions[id].media.video.q1.location,
      question1VideoAlt: this.state.questions.questions[id].media.video.q1.altText,
      question1VideoThumbnail: this.state.questions.questions[id].media.video.q1.thumbnail,
      question1VideoDuration: this.state.questions.questions[id].media.video.q1.duration,
      question2VideoLocation: this.state.questions.questions[id].media.video.q2.location,
      question2VideoAlt: this.state.questions.questions[id].media.video.q2.altText,
      question2VideoThumbnail: this.state.questions.questions[id].media.video.q2.thumbnail,
      question2VideoDuration: this.state.questions.questions[id].media.video.q2.duration,
      question3VideoLocation: this.state.questions.questions[id].media.video.q3.location,
      question3VideoAlt: this.state.questions.questions[id].media.video.q3.altText,
      question3VideoThumbnail: this.state.questions.questions[id].media.video.q3.thumbnail,
      question3VideoDuration: this.state.questions.questions[id].media.video.q3.duration,
      result1: result1,
      result1Title: this.state.questions.questions[id].results[result1].title,
      result1Subtitle: this.state.questions.questions[id].results[result1].subtitle,
      result1List: this.state.questions.questions[id].results[result1].list,
      result1Image1: this.state.questions.questions[id].media.images.column1,
      result1Image2: this.state.questions.questions[id].results[result1].image,
      result2: result2,
      result2Title: this.state.questions.questions[id].results[result2].title,
      result2Subtitle: this.state.questions.questions[id].results[result2].subtitle,
      result2List: this.state.questions.questions[id].results[result2].list,
      result2Image1: this.state.questions.questions[id].media.images.column2,
      result2Image2: this.state.questions.questions[id].results[result2].image
    }
  }


  handleChange(event) {
    const answers = {...this.state.answers};

    this.setState({
      answers: FormUtility.setFormValues(event, answers)
    }, function () {

    });
  }

  handleReset() {
    this.setState({  answers: {
        step1Question1: '',
        step1Question2: '',
        step1Question3: '',
        step1Letter: '',
        step2Question1: '',
        step2Question2: '',
        step2Question3: '',
        step2Letter: '',
        step3Question1: '',
        step3Question2: '',
        step3Question3: '',
        step3Letter: '',
        step4Question1: '',
        step4Question2: '',
        step4Question3: '',
        step4Letter: '',
      }})
  }


  checkAllAnswersHaveBeenSelected(id) {

    return (
      this.state.answers['step' + (id + 1) + 'Question1'] &&
      this.state.answers['step' + (id + 1) + 'Question2'] &&
      this.state.answers['step' + (id + 1) + 'Question3']
    );
  }


  render() {

    if (!this.state.questions) {
      return <Loading/>
    }
    return (
      <Fragment>
        <PageTracking />
        <BreadcrumbsItem to={'/'}>{this.props.t('app.name')}</BreadcrumbsItem>

        <Routes>
          <Route exact path={route('whoAmI')} element={<LandingController/>}/>
          <Route path={route('whereDoYouGainYourEnergyFrom')}
                 element={<StepController key={0} {...this.props} {...this.state} back={route('whoAmI')}
                                          next={route('howDoYouTakeInInformation')} question={this.retrieveQuestion(0)}
                                          handleChange={this.handleChange}
                                          checkAllAnswersHaveBeenSelected={this.checkAllAnswersHaveBeenSelected}
                 />}/>
          <Route path={route('howDoYouTakeInInformation')}
                 element={<StepController key={1} {...this.props} {...this.state}
                                          back={route('whereDoYouGainYourEnergyFrom')}
                                          next={route('howDoYouDecideThings')} question={this.retrieveQuestion(1)}
                                          handleChange={this.handleChange}
                                          checkAllAnswersHaveBeenSelected={this.checkAllAnswersHaveBeenSelected}
                 />}/>
          <Route path={route('howDoYouDecideThings')}
                 element={<StepController key={2} {...this.props} {...this.state}
                                          back={route('howDoYouTakeInInformation')}
                                          next={route('whatIsYourAttitudeToLife')}
                                           question={this.retrieveQuestion(2)} handleChange={this.handleChange}
                                          checkAllAnswersHaveBeenSelected={this.checkAllAnswersHaveBeenSelected}
                 />}/>
          <Route path={route('whatIsYourAttitudeToLife')}
                 element={<StepController key={3} {...this.props} {...this.state} back={route('howDoYouDecideThings')}
                                          next={route('whatYourAnswersSayAboutYou')}
                                          question={this.retrieveQuestion(3)} handleChange={this.handleChange}
                                          checkAllAnswersHaveBeenSelected={this.checkAllAnswersHaveBeenSelected}
                 />}

          />
          <Route path={route('whatYourAnswersSayAboutYou')}  element={<ResultController {...this.state} handleReset={this.handleReset}/>}/>
          <Route path="*" element={<GelContentContainer><NotFound/></GelContentContainer>}/>

        </Routes>

      </Fragment>
    );
  }
}

export default withAuthentication(withStyleguide(withRouter(withTranslation('local')(App))));
